import GlobalContactSideFilter from "./GlobalContactSideFilter";
import GlobalContactSearchResultsTable from "./GlobalContactSearchResultsTable";
import { GlobalContactSearchStateProvider } from "./GlobalContactSearchStateContext";
import { pxToRem } from "../../../utilities/uiUtils";

function GlobalContacts({initialListItems,postOnSave}) {
  return (
    <GlobalContactSearchStateProvider>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
          alignItems: "flex-start",
          padding: "1vh",
          // height:"100%",
        }}
      >
        <GlobalContactSideFilter />
        {/* <div style={{ height: "98%", borderRight: "solid 0.1rem #f4f1f6" }} /> */}
        <GlobalContactSearchResultsTable initialListItems={initialListItems}
        postOnSave={postOnSave}
        />

      </div>
    </GlobalContactSearchStateProvider>
  );
}

export default GlobalContacts;
